var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarMenu)?_c('div',{staticClass:"mt-2"},[_vm._m(0),_c('b-list-group',[_c('relacao-etapas'),_c('relacao-etapas-gestores'),_c('relacao-etapas-gerentes'),_c('relacao-etapas-apoios'),_c('relacao-etapas-cancelamento'),_c('relatorio-faturamento-etapas')],1)],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"heading-1"},[_c('span',[_vm._v("SGTEC")])])
}]

export { render, staticRenderFns }